export var isExternalHref = function (href) {
  return !!(href && (href.match(/data:/i) || href.match(/mailto:/i) || href.match(/http(s?)/)));
};